import { OnboardingModal } from '@ascd/witsby-components';
import { PROFILE_FORM_TYPE } from '@constants';
import { useProfileForm } from '@utils';

const OnboardModal = () => {
  const {
    givenName,
    handleUpdateProfile,
    modalOff = false,
  } = useProfileForm(PROFILE_FORM_TYPE.UPDATE);

  return (
    <OnboardingModal
      handleSubmitForm={() => handleUpdateProfile({ modalOff: true })}
      givenName={givenName}
      modalOff={modalOff}
    />
  );
};

export default OnboardModal;
